<template>
  <section class="fabric-type">
    <div
      class="input"
      style="margin-bottom: 0;"
    >
      <p
        class="text-body-m fabric-type__title"
        style="margin-bottom: 5px;"
      >
        {{ $t('fabric_type') }}
      </p>
      <input
        :value="valueTextileList"
        type="text"
        name="factory[textile_list]"
        aria-label=""
        style="display: none"
      />
      <multiselect
        :class="{'multiselect--multiple': true}"
        :value="valueTextileList"
        tag-placeholder="Add this as new tag"
        :placeholder="$t('search')"
        :close-on-select="false"
        :options="optionsTextileList"
        :multiple="true"
        :taggable="true"
        @input="$emit('valueTextileListChange', $event)"
        @tag="(newTag) => addTag(newTag, 'valueTextileList')"
      />
      <div class="factory-create__hints-wrap">
        <a
          v-for="hint in hintsTextileList"
          :key="hint"
          @click="() => onHintsClick(hint, 'valueTextileList')"
        >
          {{ hint }}
        </a>
      </div>
    </div>
  </section>
</template>

<script>
    export default {
        name: 'FabricType',
        props: {
            valueTextileList: {
                default: () => [],
            },
            optionsTextileList: {
                default: () => [],
            },
            hintsTextileList: {
                default: () => [],
            },
        },
        methods: {
            onHintsClick(hint, valueItem) {
                if (Array.isArray(this[valueItem]) && this[valueItem].find(value => value === hint)) return
                const result = this[valueItem] || []
                this.$emit(`${valueItem}Change`, [...result, hint])
            },
          addTag(newTag, valueItem) {
            try {
              newTag.split(',').forEach((tag) => {
                if (!tag.trim()) return
                setTimeout(() => {
                  this.$emit(`${valueItem}Change`, [...this[valueItem], tag.trim()])
                }, 10)
              })
            } catch (e) {
              console.error()
            }
          },
        },
    }
</script>

<style scoped>

</style>
